import { Component } from '@angular/core';
import { DigitalAssetsManagementItemComponent } from 'gung-standard';

@Component({
    selector: 'tylo-digital-assets-management-item',
    templateUrl: './tylo-digital-assets-management-item.component.html',
    styleUrls: ['./tylo-digital-assets-management-item.component.css'],
    standalone: false
})
export class TyloDigitalAssetsManagementItemComponent extends DigitalAssetsManagementItemComponent {

}
